export default __webpack_public_path__ + "static/media/frame-close.d45965a1.svg";